import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { usePageMeta } from "../lib/api";

const About = () => {
  usePageMeta(
    "About Show Me Shield | Independent Missouri Insurance Brokerage",
    "Show Me Shield exists to make insurance conversations easier. Learn how our independent Missouri brokerage helps families understand supplemental, life and health protection.",
    { path: "/about" }
  );

  return (
    <main className="bg-paper">
      <div className="border-b border-ink/10 bg-ink grid-lines">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24">
          <Reveal>
            <p className="eyebrow mb-4">About Show Me Shield</p>
            <h1 className="h-display max-w-3xl text-4xl text-white sm:text-5xl lg:text-6xl">
              Insurance should feel like a conversation.
            </h1>
          </Reveal>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24">
        <div className="grid items-start gap-12 lg:grid-cols-2">
          <Reveal>
            <div className="space-y-5 text-base leading-relaxed text-primer sm:text-lg">
              <p>
                People often know they have insurance. What they don&apos;t always know is what happens
                financially when something serious actually occurs.
              </p>
              <p className="font-semibold text-ink">
                Show Me Shield exists to make those conversations easier.
              </p>
              <p>
                We&apos;re an independent insurance brokerage — which means we&apos;re not here to push
                one company&apos;s product. We help Missouri individuals and families look at what
                their current coverage actually does, identify the gaps that matter, and evaluate
                supplemental, health, and life options that fit their situation.
              </p>
              <p>
                Insurance shouldn&apos;t require an insurance dictionary. If something happened
                tomorrow, you should know what your coverage would actually do. That&apos;s the whole
                idea behind our name: don&apos;t just tell me — show me.
              </p>
              <div className="flex items-center gap-3 border-l-2 border-lime pl-4 font-display text-lg font-semibold uppercase tracking-wide text-ink">
                <MapPin className="h-5 w-5 text-lime-dim" />
                Independent brokerage. Missouri values. Plain language.
              </div>
            </div>
            <Link to="/contact" data-testid="about-cta" className="btn-lime mt-9">
              Let&apos;s Look at Your Shield <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>

          <Reveal delay={120}>
            <div className="space-y-6">
              <div className="relative overflow-hidden rounded-md border border-ink/10">
                <img
                  src="/assets/brand/founder-office.webp"
                  width="1100"
                  height="1493"
                  alt="Inside the Show Me Shield office — a Missouri insurance broker ready for a real conversation"
                  className="w-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="grid grid-cols-3 gap-4">
                {[
                  { big: "Show", small: "the gaps, honestly" },
                  { big: "Explain", small: "before recommending" },
                  { big: "Stay", small: "after the policy begins" },
                ].map((v) => (
                  <div key={v.big} className="card-light !p-4 text-center">
                    <p className="font-display text-xl font-bold uppercase text-ink">{v.big}</p>
                    <p className="mt-1 text-xs text-primer">{v.small}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </main>
  );
};

export default About;
